/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
} from '@material-ui/core';
import FavoriteTwoToneIcon from '@material-ui/icons/FavoriteTwoTone';
import CloseIcon from '@material-ui/icons/Close';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import Carousel from "react-simply-carousel";
import {
  FavoriteBorderOutlined,
  FavoriteTwoTone,
  KeyboardArrowDown,
  MoreHoriz,
} from '@material-ui/icons';
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import { Element, scroller, Link as ScrollLink } from 'react-scroll';
import { backendUrl, homesBaseUrlForCommunity } from '../../../constants/globalConstants';
import useCommunityList from '../../../hooks/useCommunityList';
import AboutCommunity from '../AboutCommunity/AboutCommunity';
import Amenities from '../Amenities/Amenities';
import Climate from '../Climate/Climate';
import ClubsAndConnections from '../ClubsAndConnections/ClubsAndConnections';
import CommunityCoverPhoto from '../CommunityCoverPhoto/CommunityCoverPhoto';
import CostOfLiving from '../CostOfLiving/CostOfLiving';
import Education from '../Education/Education';
import GettingAround from '../GettingAround/GettingAround';
import Healthcare from '../Healthcare/HealthCare';
import InsightsBy from '../InsightsBy/InsightsBy';
import Jobs from '../Jobs/Jobs';
import Residents from '../Residents/Residents';
import ViewPublic from '../ViewPublic/ViewPublic';
import CommunityNavigationDialog from './CommunityNavigationDialog';
import CommunityProfileTracker from './CommunityProfileTracker';
import Login from '../../Auth/Login/Login';
import ClubCommunity from '../ClubsNew/ClubCommunity';
const CommunityDetails = (props) => {
  const loc = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const key = 'iFrasCwdJh';
  const [communityDetails, setCommunityDetails] = useState(null);
  const [isVideoApproved, setVideoApproved] = useState(true);
  const {
    getCommunityDetailById,
    readVideoNotification,
    addCommunityAsFavourite,
    getStatusById,
  } = useCommunityList();
  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  const [userId] = useState(loggedInUserData?.id);
  const [isCommunityRepresentative, setCommunityRepresentative] = useState(
    params?.id === loggedInUserData?.communityId,
  );

  const [isAccessible, setIsAccessible] = React.useState(
    (loggedInUserData?.id && communityDetails?.userrole?.[0]?.id === loggedInUserData?.id) ||
      loggedInUserData?.roleId === 2,
  );
  const [isAdmin, setIsAdmin] = React.useState(loggedInUserData?.roleId === 2);

  const [publicView, setPublicView] = useState(false);
  const [navigationDialogOpen, setNavigationDialogOpen] = useState(false);
  const [isFav, setIsFav] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [changeTabSignUp, setChangeTabSignUp] = React.useState(0);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = React.useState(null);
  const actionMenuOpen = Boolean(actionMenuAnchorEl);

  const handleClickOpen = (tabs) => {
    setOpen(true);
    setChangeTabSignUp(tabs);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleActionMenuClick = (event) => {
    setActionMenuAnchorEl(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
  };

  // Handle favorite toggle - based on CommunityCard.js
  const handleFavToggle = async (communityId) => {
    if (userId !== null && userId !== undefined) {
      try {
        console.log('Toggling favorite for community:', communityId, 'user:', userId);
        const favResult = await addCommunityAsFavourite({
          communityId,
          userId,
          typeText: 'community',
        });
        console.log('Toggle result:', favResult);

        if (favResult) {
          setIsFav(favResult?.responseData?.isFavourite);
        }
      } catch (error) {
        console.error('Error toggling favorite:', error);
      }
    } else {
      console.log('User not logged in, userId:', userId);
      handleClickOpen(0);
    }
  };

  // Set community status - based on CommunityCard.js
  const setCommunityStatus = async () => {
    if (userId !== null && userId !== undefined && params?.id) {
      try {
        const favResult = await getStatusById({ communityId: params.id, userId });
        console.log('Get status result:', favResult);
        setIsFav(favResult?.usersResult?.isFavourite);
      } catch (error) {
        console.error('Error getting favorite status:', error);
      }
    }
  };

  const fillCommunityDetails = async () => {
    let communityDetailsResults = [];
    if (params?.id) {
      communityDetailsResults = await getCommunityDetailById({
        communityId: params?.id,
        userId,
        amenityFeatureFlag: true,
      });
      setCommunityDetails(communityDetailsResults?.data);
    }
    setCommunityRepresentative(
      params?.id === loggedInUserData?.communityId && communityDetailsResults?.data?.isRepresented,
    );
    // return communityDetailsResults?.data;
  };

  const checkVideoStatus = async () => {
    // Function to close the video approval box
    const response = await readVideoNotification({ videoId: videoData.requestId }); // Use communityId
    if (response.status === true) {
      //console.log(response);
    }
    setVideoApproved(false);
  };

  const hashFragment = loc.hash.substring(1);

  useEffect(() => {
    // Scroll to Section1 with offset of -100 when component mounts
    if (hashFragment) {
      setTimeout(() => {
        scroller.scrollTo(hashFragment, {
          duration: 500,
          spy: true,
          smooth: true,
          offset: -140,
        });
      }, 1500);
    }
  }, [loc, communityDetails]);

  useEffect(() => {
    //checkVideoStatus();
  }, []);
  // const sectionRef = useRef(null);
  // useLayoutEffect(() => {
  //   const sectionElement = document.querySelector('[name="Section2"]');
  //   if (hashFragment) {
  //     console.log(sectionElement, 4444);
  //   }
  // }, []);

  useEffect(() => {
    // Check if the query parameter is present
    if (loc.search.includes('?section=section3')) {
      // Use react-router-dom navigate to scroll to the hash fragment
      navigate(loc.pathname + '#Section3');
    }
  }, [navigate, loc.search, loc.pathname]);

  useEffect(() => {
    fillCommunityDetails();
    setCommunityStatus();
  }, []);
  const [activeSlide, setActiveSlide] = useState(0);
  var items = [
    {
      Image: 'assets/amenities/Slide.jpg',
    },
    {
      Image: 'assets/amenities/Slide.jpg',
    },
  ];
  useEffect(() => {
    setIsAccessible(
      (loggedInUserData?.id && communityDetails?.userrole?.[0]?.id === loggedInUserData?.id) ||
        loggedInUserData?.roleId === 2,
    );
  }, [communityDetails]);

  const handleNavigationDialogOpen = () => {
    setNavigationDialogOpen(true);
  };

  const handleNavigationDialogClose = () => {
    setNavigationDialogOpen(false);
  };

  const ViewButton = () => (
    <>
      View all homes in {communityDetails.communityNameText}
      <Box component="span" marginLeft={1}>
        <ArrowForwardIcon />
      </Box>
    </>
  );

  return (
    <>
      {console.log(communityDetails, 2222)}
      {communityDetails ? (
        <Box component="div" className="communityDetailsContainer ">
          <Box
            component="div"
            className="communityDetailsBannerbg"
            style={{
              backgroundImage: `url(
                      ${require(`../../../assets/images/CD-Pattern.jpg`).default}
                    )`,
            }}
          ></Box>
          <Box className="communityDetailsSidebar">
            <Box className="SidebarContent">
              <Container className="CustomContainer communityDetailsSidebarContainer">
                <Box className="communityDetailsSidebarHeader">
                  <Box className="MenuViewContent">
                    <Box component="span" className="CommunityBadgeBox">
                      {/* <Box component="span" className="CommunityBadgeBox">
                      {cmObj?.isRepresented && <CommunityBadge badgeName="represented" />}
                      {Boolean(isRecommended) && <CommunityBadge badgeName="reccomended" />}
                    </Box> */}
                      {/* Rahat Note above is code from CommunityCard.js which import from CommunityBadge.js below I'm just adding image placeholder for now*/}
                      <img
                        className="BadgeIcon RepresentedBadgeIcon"
                        src={require('../../../assets/images/Badge-Icon-White.svg').default}
                        alt="Badge Icon"
                      />
                    </Box>
                    <Box className="communityDetailsSidebarInfoName">
                      <Typography className="CityNameHeading" variant="h4" component="h4">
                        {communityDetails?.communityNameText}
                        {','}
                      </Typography>
                      <Typography variant="h4" component="h4" className="StateNameHeading">
                        {communityDetails?.stateCommunities?.stateShortName}
                      </Typography>
                    </Box>
                    <Box className="communityDetailsSidebarToggleButton">
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          handleFavToggle(params?.id);
                        }}
                        style={{
                          cursor: 'pointer',
                          padding: '8px',
                          //  backgroundColor: 'rgba(255,255,255,0.1)',
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {isFav ? (
                          <FavoriteTwoToneIcon
                            style={{
                              color: '#FFFFFF',
                              fontSize: '24px',
                            }}
                          />
                        ) : (
                          <FavoriteBorderOutlined />
                        )}
                      </Box>
                    </Box>
                    {isAccessible && !publicView && (
                      <Box className="communityDetailsSidebarActionButton ">
                        <Box
                          aria-label="more"
                          aria-controls="action-menu"
                          aria-haspopup="true"
                          onClick={handleActionMenuClick}
                          className="MoreHorizIcon"
                          style={{ cursor: 'pointer' }}
                        >
                          <MoreHoriz style={{ color: '#FFFFFF' }} />
                        </Box>

                        <Menu
                          className="ActionButtonPopup"
                          id="action-menu"
                          anchorEl={actionMenuAnchorEl}
                          keepMounted
                          open={actionMenuOpen}
                          onClose={handleActionMenuClose}
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        >
                          <MenuItem
                            className="ActionButtonContainer"
                            onClick={() => {
                              setTimeout(() => {
                                window.scrollTo(0, 0);
                              }, 1);
                              setPublicView(true);
                              handleActionMenuClose();
                            }}
                          >
                            <ListItemIcon className="ActionButtonIcon">
                              <img
                                src={require('../../../assets/images/PublicView.svg').default}
                                alt="PublicView"
                              />
                            </ListItemIcon>
                            <Typography variant="inherit">Public View</Typography>
                          </MenuItem>
                          {loggedInUserData?.roleId === 1 && (
                            <MenuItem
                              className="ActionButtonContainer LeaveCommunity"
                              onClick={() => {
                                if (params?.id) navigate(`/app/leave-community/${params.id}`);
                              }}
                            >
                              <ListItemIcon className="ActionButtonIcon">
                                <img
                                  src={require('../../../assets/images/LeaveCommunity.svg').default}
                                  alt="LeaveCommunity"
                                />
                              </ListItemIcon>
                              <Typography variant="inherit">Leave Community</Typography>
                            </MenuItem>
                          )}
                        </Menu>
                      </Box>
                    )}
                  </Box>
                  <Box
                    className="MenuViewButton"
                    onClick={handleNavigationDialogOpen}
                    style={{ cursor: 'pointer' }}
                  >
                    <Typography
                      className="DropdownText"
                      variant="body2"
                      component="div"
                      color="white"
                    >
                      View
                    </Typography>
                    <KeyboardArrowDown />
                  </Box>
                </Box>
                <Box className="communityDetailsSidebarHeaderNav">
                  <ul className="nav navbar-nav">
                    {(isAccessible && !publicView) ||
                    communityDetails?.amenities?.length ||
                    communityDetails?.ammenitiesInsight?.amenityDesc ? (
                      <li>
                        <ScrollLink
                          activeClass="active"
                          className="Section1"
                          to="Section1"
                          spy={true}
                          smooth={true}
                          duration={500}
                          offset={-140}
                        >
                          Amenities
                        </ScrollLink>
                      </li>
                    ) : (
                      ''
                    )}

                    <If
                      condition={
                        (isAccessible && !publicView) ||
                        (communityDetails?.communityVideo?.length &&
                          communityDetails?.communityVideo?.find(
                            (x) => x.approvedStatus?.toLowerCase() == 'approved',
                          )?.id) ||
                        (communityDetails?.aboutDesc && communityDetails?.aboutDesc !== '')
                      }
                    >
                      <li>
                        <ScrollLink
                          activeClass="active"
                          className="Section3"
                          to="Section3"
                          spy={true}
                          smooth={true}
                          duration={500}
                          offset={-140}
                        >
                          About
                        </ScrollLink>
                      </li>
                    </If>

                    {(!publicView ||
                      (publicView && communityDetails?.clubCount > 0) ||
                      (communityDetails?.clubInsight &&
                        communityDetails?.clubInsight?.clubDesc !== '')) &&
                      (isAccessible ||
                        (!isAccessible &&
                          (communityDetails?.clubCount > 0 ||
                            (communityDetails?.clubInsight &&
                              communityDetails?.clubInsight?.clubDesc !== '')))) && (
                        <li>
                          <ScrollLink
                            activeClass="active"
                            className="Section12"
                            to="Section12"
                            spy={true}
                            smooth={true}
                            duration={500}
                            offset={-140}
                          >
                            Clubs & Connections
                          </ScrollLink>
                        </li>
                      )}

                    <li>
                      <ScrollLink
                        activeClass="active"
                        className="Section5"
                        to="Section5"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-140}
                      >
                        Jobs
                      </ScrollLink>
                    </li>

                    <li>
                      <ScrollLink
                        activeClass="active"
                        className="Section6"
                        to="Section6"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-140}
                      >
                        Residents
                      </ScrollLink>
                    </li>

                    <li>
                      <ScrollLink
                        activeClass="active"
                        className="Section7"
                        to="Section7"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-140}
                      >
                        Cost of Living
                      </ScrollLink>
                    </li>

                    <If condition={!publicView}>
                      <Choose>
                        <When
                          condition={
                            !isAccessible &&
                            communityDetails?.climate &&
                            communityDetails?.climate?.length > 0 &&
                            communityDetails?.climate?.[0] &&
                            (communityDetails?.climate?.[0]?.climateDesc !== '' ||
                              communityDetails?.climate?.[0]?.climateType !== '')
                          }
                        >
                          <li>
                            <ScrollLink
                              activeClass="active"
                              className="Section8"
                              to="Section8"
                              spy={true}
                              smooth={true}
                              duration={500}
                              offset={-140}
                            >
                              Climate
                            </ScrollLink>
                          </li>
                        </When>
                        <When condition={isAccessible}>
                          <li>
                            <ScrollLink
                              activeClass="active"
                              className="Section8"
                              to="Section8"
                              spy={true}
                              smooth={true}
                              duration={500}
                              offset={-140}
                            >
                              Climate
                            </ScrollLink>
                          </li>
                        </When>
                      </Choose>
                    </If>

                    <If condition={publicView}>
                      <If
                        condition={
                          communityDetails?.climate &&
                          communityDetails?.climate?.length > 0 &&
                          communityDetails?.climate?.[0] &&
                          (communityDetails?.climate?.[0]?.climateDesc !== '' ||
                            communityDetails?.climate?.[0]?.climateType !== '')
                        }
                      >
                        <li>
                          <ScrollLink
                            activeClass="active"
                            className="Section8"
                            to="Section8"
                            spy={true}
                            smooth={true}
                            duration={500}
                            offset={-140}
                          >
                            Climate
                          </ScrollLink>
                        </li>
                      </If>
                    </If>

                    <If condition={!publicView}>
                      <Choose>
                        <When
                          condition={
                            !isAccessible &&
                            communityDetails?.gettingAround.length > 0 &&
                            communityDetails?.gettingAround?.[0] &&
                            (communityDetails?.gettingAround?.[0]?.dedicatedBikingPaths ||
                              communityDetails?.gettingAround?.[0]?.dedicatedWalkingPaths ||
                              communityDetails?.gettingAround?.[0]?.regionalAirport ||
                              communityDetails?.gettingAround?.[0]?.localAirport ||
                              communityDetails?.gettingAround?.[0]?.publicTransType !== '' ||
                              communityDetails?.gettingAround?.[0]?.gettingAroundDesc !== '')
                          }
                        >
                          <li>
                            <ScrollLink
                              activeClass="active"
                              className="Section9"
                              to="Section9"
                              spy={true}
                              smooth={true}
                              duration={500}
                              offset={-140}
                            >
                              Getting Around
                            </ScrollLink>
                          </li>
                        </When>
                        <When condition={isAccessible}>
                          <li>
                            <ScrollLink
                              activeClass="active"
                              className="Section9"
                              to="Section9"
                              spy={true}
                              smooth={true}
                              duration={500}
                              offset={-140}
                            >
                              Getting Around
                            </ScrollLink>
                          </li>
                        </When>
                      </Choose>
                    </If>

                    <If condition={publicView}>
                      {
                        // communityDetails?.isRepresented &&
                        isAccessible &&
                          communityDetails?.gettingAround.length > 0 &&
                          communityDetails?.gettingAround?.[0] &&
                          (communityDetails?.gettingAround?.[0]?.dedicatedBikingPaths ||
                            communityDetails?.gettingAround?.[0]?.dedicatedWalkingPaths ||
                            communityDetails?.gettingAround?.[0]?.regionalAirport ||
                            communityDetails?.gettingAround?.[0]?.localAirport ||
                            communityDetails?.gettingAround?.[0]?.publicTransType !== '' ||
                            communityDetails?.gettingAround?.[0]?.gettingAroundDesc !== '') && (
                            <li>
                              <ScrollLink
                                activeClass="active"
                                className="Section9"
                                to="Section9"
                                spy={true}
                                smooth={true}
                                duration={500}
                                offset={-140}
                              >
                                Getting Around
                              </ScrollLink>
                            </li>
                          )
                      }
                    </If>

                    <li>
                      <ScrollLink
                        activeClass="active"
                        className="Section10"
                        to="Section10"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-140}
                      >
                        Education
                      </ScrollLink>
                    </li>
                    <If
                      condition={
                        (isAccessible && !publicView) ||
                        communityDetails?.healthFacilityCount > 0 ||
                        (communityDetails?.healthInsights?.length > 0 &&
                          communityDetails?.healthInsights?.[0]?.healthCareDesc !== '')
                      }
                    >
                      <li>
                        <ScrollLink
                          activeClass="active"
                          className="Section11"
                          to="Section11"
                          spy={true}
                          smooth={true}
                          duration={500}
                          offset={-140}
                        >
                          Healthcare
                        </ScrollLink>
                      </li>
                    </If>
                    {/* <Divider /> */}
                    {/* <Box mb={2} mt={2}>
                      <Link
                        href={`${
                          communityDetails?.planetReCommunityId
                            ? `${homesBaseUrlForCommunity}${communityDetails.planetReCommunityId}`
                            : ''
                        }`}
                        target="_blank"
                        disable={false}
                        underline="none"
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          fullWidth
                          // startIcon={<HouseIcon />}
                        >
                          View Homes
                        </Button>
                      </Link>
                    </Box> */}
                  </ul>
                  <Box className="ViewHomesButtonDesktop">
                    <Link
                      href={`${
                        communityDetails?.planetReCommunityId
                          ? `${homesBaseUrlForCommunity}${communityDetails.planetReCommunityId}`
                          : ''
                      }`}
                      target="_blank"
                      disable={false}
                      underline="none"
                    >
                      <Button variant="outlined" color="secondary" size="small">
                        View Homes
                      </Button>
                    </Link>
                  </Box>
                </Box>
              </Container>
            </Box>
          </Box>

          <Container className="CustomContainer">
            {/* <Paper className="BackButton">
            <Box className="FlexCenter">
              <ArrowBackIcon color='primary' />
              <ScrollLink
                className="BackButtonLink"
                onClick={() => {
                  navigate('../community-list');
                }}
              >
                {communityDetails?.communityNameText}
              </ScrollLink>
            </Box>
            <MoreHorizIcon className="GreenColor" />
          </Paper> */}
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              className="communityDetailsContent"
            >
              <Grid item xs={12} sm={12}>
                <If condition={isAccessible && !publicView}>
                  <CommunityProfileTracker communityDetails={communityDetails} />
                </If>
                <Box component="div" className="ScrollerBoxCD">
                  <If condition={isAccessible && publicView}>
                    <ViewPublic setPublicView={setPublicView} />
                  </If>
                  <Choose>
                    <When
                      // condition={communityDetails && !communityDetails?.isRepresented && !isAdmin}
                      condition={communityDetails && !communityDetails?.isRepresented && !isAdmin}
                    >
                      <Box key={communityDetails?.id}>
                        <Element name="">
                          <Box
                            className="CardBannerSection"
                            style={{
                              backgroundImage: `url(${
                                communityDetails?.images
                                  ? backendUrl + communityDetails?.images
                                  : require(`../../../assets/images/community-Empty-Image.jpg`)
                                      .default
                              })`,
                            }}
                          ></Box>
                          <CommunityCoverPhoto
                            communityDetails={communityDetails}
                            listView={false}
                            favStatus={loc?.state?.isFavourite}
                            actionButton={true}
                            isAccessible={isAccessible}
                            setPublicView={setPublicView}
                            publicView={publicView}
                            fillCommunityDetails={fillCommunityDetails}
                          />
                        </Element>
                        {(isAccessible && !publicView) ||
                        communityDetails?.amenities?.length ||
                        communityDetails?.ammenitiesInsight?.amenityDesc ? (
                          <Element name="Section1" className="AmenitiesModule">
                            <Amenities
                              communityInfo={communityDetails}
                              isAccessible={isAccessible}
                              publicView={publicView}
                              loggedInUserData={loggedInUserData}
                            />
                          </Element>
                        ) : (
                          ''
                        )}

                        <If
                          condition={
                            (isAccessible && !publicView) ||
                            (communityDetails?.communityVideo?.length &&
                              communityDetails?.communityVideo?.find(
                                (x) => x.approvedStatus?.toLowerCase() == 'approved',
                              )?.id) ||
                            (communityDetails?.aboutDesc && communityDetails?.aboutDesc !== '')
                          }
                        >
                          <Element name="Section3" className="AboutCommunityModule">
                            <AboutCommunity
                              communityInfo={communityDetails}
                              isAccessible={isAccessible}
                              publicView={publicView}
                            />
                          </Element>
                        </If>

                        {(!publicView ||
                          (publicView && communityDetails?.clubCount > 0) ||
                          (communityDetails?.clubInsight &&
                            communityDetails?.clubInsight?.clubDesc !== '')) &&
                          (isAccessible ||
                            (!isAccessible &&
                              (communityDetails?.clubCount > 0 ||
                                (communityDetails?.clubInsight &&
                                  communityDetails?.clubInsight?.clubDesc !== '')))) && (
                            <Element name="Section12" className="ClubsConnectionsModule">
                              <ClubCommunity
                                communityInfo={communityDetails}
                                isAccessible={isAccessible}
                                publicView={publicView}
                                loggedInUserData={loggedInUserData}
                              />
                            </Element>
                          )}

                        <Element name="Section5">
                          <Jobs communityInfo={communityDetails} />
                        </Element>
                        <Element name="Section2">
                          <Residents communityInfo={communityDetails} />
                        </Element>
                        <Element name="Section7">
                          <CostOfLiving communityInfo={communityDetails} />
                        </Element>
                        <If condition={!publicView}>
                          <Choose>
                            <When
                              condition={
                                !isAccessible &&
                                communityDetails?.climate &&
                                communityDetails?.climate.length > 0 &&
                                communityDetails?.climate?.[0] &&
                                (communityDetails?.climate?.[0]?.climateDesc !== '' ||
                                  communityDetails?.climate?.[0]?.climateType !== '')
                              }
                            >
                              <Element name="Section8" className="ClimateModule">
                                <Climate
                                  communityInfo={communityDetails}
                                  communityDetails={communityDetails}
                                  isAccessible={isAccessible}
                                  publicView={publicView}
                                  loggedInUserData={loggedInUserData}
                                />
                              </Element>
                            </When>
                            <When condition={isAccessible}>
                              <Element name="Section8" className="ClimateModule">
                                <Climate
                                  communityInfo={communityDetails}
                                  communityDetails={communityDetails}
                                  isAccessible={isAccessible}
                                  publicView={publicView}
                                  loggedInUserData={loggedInUserData}
                                />
                              </Element>
                            </When>
                          </Choose>
                        </If>

                        <If condition={!publicView}>
                          <Choose>
                            <When
                              condition={
                                !isAccessible &&
                                communityDetails?.gettingAround?.length > 0 &&
                                communityDetails?.gettingAround?.[0] &&
                                (communityDetails?.gettingAround?.[0]?.dedicatedBikingPaths ||
                                  communityDetails?.gettingAround?.[0]?.dedicatedWalkingPaths ||
                                  communityDetails?.gettingAround?.[0]?.regionalAirport ||
                                  communityDetails?.gettingAround?.[0]?.localAirport ||
                                  communityDetails?.gettingAround?.[0]?.publicTransType !== '' ||
                                  communityDetails?.gettingAround?.[0]?.gettingAroundDesc !== '')
                              }
                            >
                              <Element name="Section9" className="GettingAroundModule">
                                <GettingAround
                                  communityInfo={communityDetails}
                                  communityDetails={communityDetails}
                                  isAccessible={isAccessible}
                                  publicView={publicView}
                                  loggedInUserData={loggedInUserData}
                                />
                              </Element>
                            </When>
                            <When condition={isAccessible && communityDetails?.isRepresented}>
                              <Element name="Section9" className="GettingAroundModule">
                                <GettingAround
                                  communityInfo={communityDetails}
                                  communityDetails={communityDetails}
                                  isAccessible={isAccessible}
                                  publicView={publicView}
                                  loggedInUserData={loggedInUserData}
                                />
                              </Element>
                            </When>
                          </Choose>
                        </If>
                        <Element name="Section10" className="EducationModule">
                          <Education
                            communityInfo={communityDetails}
                            communityDetails={communityDetails}
                            isAccessible={isAccessible}
                            publicView={publicView}
                            loggedInUserData={loggedInUserData}
                          />
                        </Element>
                        <If
                          condition={
                            (isAccessible && !publicView) ||
                            communityDetails?.healthFacilityCount > 0 ||
                            (communityDetails?.healthInsights?.length > 0 &&
                              communityDetails?.healthInsights?.[0]?.healthCareDesc !== '')
                          }
                        >
                          <Element name="Section11" className="HealthcareModule">
                            <Healthcare
                              communityInfo={communityDetails}
                              isAccessible={isAccessible}
                              publicView={publicView}
                              loggedInUserData={loggedInUserData}
                            />
                          </Element>
                        </If>
                        <If condition={publicView}>
                          {console.log(
                            isAccessible &&
                              ((communityDetails?.healthInsights?.length > 0 &&
                                communityDetails?.healthInsights?.[0]?.healthCareDesc !== '') ||
                                (communityDetails?.healthFacility?.length > 0 &&
                                  communityDetails?.healthFacility?.find(
                                    (x) =>
                                      x.repId === communityDetails?.userrole[0]?.id ||
                                      x.isAdminEntry,
                                  )) ||
                                false),
                            8686,
                          )}
                          <If
                            condition={
                              !publicView &&
                              (isAccessible ||
                                communityDetails?.healthFacilityCount > 0 ||
                                (communityDetails?.healthInsights?.length > 0 &&
                                  communityDetails?.healthInsights?.[0]?.healthCareDesc !== ''))
                            }
                          >
                            <li>
                              <ScrollLink
                                activeClass="active"
                                className="Section11"
                                to="Section11"
                                spy={true}
                                smooth={true}
                                duration={500}
                                offset={-140}
                              >
                                Healthcare
                              </ScrollLink>
                            </li>
                          </If>
                        </If>
                      </Box>
                    </When>
                    {/* <When condition={communityDetails && communityDetails?.isRepresented}> */}

                    <When condition={communityDetails}>
                      <Element name="" className="CommunityCoverPhotoModule">
                        <CommunityCoverPhoto
                          communityDetails={communityDetails}
                          listView={false}
                          favStatus={loc?.state?.isFavourite}
                          actionButton={true}
                          isAccessible={isAccessible}
                          setPublicView={setPublicView}
                          publicView={publicView}
                          fillCommunityDetails={fillCommunityDetails}
                        />
                      </Element>

                      {(isAccessible && !publicView) ||
                      communityDetails?.amenities?.length ||
                      communityDetails?.ammenitiesInsight?.amenityDesc ? (
                        <Element name="Section1" className="AmenitiesModule">
                          <Amenities
                            communityInfo={communityDetails}
                            isAccessible={isAccessible}
                            publicView={publicView}
                            loggedInUserData={loggedInUserData}
                          />
                        </Element>
                      ) : (
                        ''
                      )}
                      <If condition={communityDetails?.isRepresented}>
                        <Element name="Section2" className="InsightsByModule">
                          <InsightsBy
                            communityInfo={communityDetails}
                            isAccessible={isAccessible}
                            publicView={publicView}
                            loggedInUserData={loggedInUserData}
                          />
                        </Element>
                      </If>

                      <If
                        condition={
                          (isAccessible && !publicView) ||
                          (communityDetails?.communityVideo?.length &&
                            communityDetails?.communityVideo?.find(
                              (x) => x.approvedStatus?.toLowerCase() == 'approved',
                            )?.id) ||
                          (communityDetails?.aboutDesc && communityDetails?.aboutDesc !== '')
                        }
                      >
                        <Element name="Section3" className="AboutCommunityModule">
                          <AboutCommunity
                            communityInfo={communityDetails}
                            isAccessible={isAccessible}
                            publicView={publicView}
                          />
                        </Element>
                      </If>
                      {/* <Element name="Section4" className="CommunityMapModule">
                        <CommunityMap />
                      </Element> */}

                      {(!publicView ||
                        (publicView && communityDetails?.clubCount > 0) ||
                        (communityDetails?.clubInsight &&
                          communityDetails?.clubInsight?.clubDesc !== '')) &&
                        (isAccessible ||
                          (!isAccessible &&
                            (communityDetails?.clubCount > 0 ||
                              (communityDetails?.clubInsight &&
                                communityDetails?.clubInsight?.clubDesc !== '')))) && (
                          <Element name="Section12" className="ClubsConnectionsModule">
                            <ClubCommunity
                              communityInfo={communityDetails}
                              isAccessible={isAccessible}
                              publicView={publicView}
                              loggedInUserData={loggedInUserData}
                            />
                          </Element>
                        )}

                      <Element name="Section5" className="JobsModule">
                        <Jobs
                          communityInfo={communityDetails}
                          communityDetails={communityDetails}
                          isAccessible={isAccessible}
                          publicView={publicView}
                          loggedInUserData={loggedInUserData}
                        />
                      </Element>
                      <Element name="Section6" className="ResidentsModule">
                        <Residents
                          communityInfo={communityDetails}
                          communityDetails={communityDetails}
                          isAccessible={isAccessible}
                          publicView={publicView}
                          loggedInUserData={loggedInUserData}
                        />
                      </Element>
                      <Element name="Section7" className="CostOfLivingModule">
                        <CostOfLiving
                          communityInfo={communityDetails}
                          communityDetails={communityDetails}
                          isAccessible={isAccessible}
                          publicView={publicView}
                          loggedInUserData={loggedInUserData}
                        />
                      </Element>
                      <If condition={!publicView}>
                        <Choose>
                          <When
                            condition={
                              !isAccessible &&
                              communityDetails?.climate &&
                              communityDetails?.climate.length > 0 &&
                              communityDetails?.climate?.[0] &&
                              (communityDetails?.climate?.[0]?.climateDesc !== '' ||
                                communityDetails?.climate?.[0]?.climateType !== '')
                            }
                          >
                            <Element name="Section8" className="ClimateModule">
                              <Climate
                                communityInfo={communityDetails}
                                communityDetails={communityDetails}
                                isAccessible={isAccessible}
                                publicView={publicView}
                                loggedInUserData={loggedInUserData}
                              />
                            </Element>
                          </When>
                          <When condition={isAccessible}>
                            <Element name="Section8" className="ClimateModule">
                              <Climate
                                communityInfo={communityDetails}
                                communityDetails={communityDetails}
                                isAccessible={isAccessible}
                                publicView={publicView}
                                loggedInUserData={loggedInUserData}
                              />
                            </Element>
                          </When>
                        </Choose>
                      </If>

                      <If condition={publicView}>
                        <If
                          condition={
                            communityDetails?.climate &&
                            communityDetails?.climate?.length > 0 &&
                            communityDetails?.climate?.[0] &&
                            (communityDetails?.climate?.[0]?.climateDesc !== '' ||
                              communityDetails?.climate?.[0]?.climateType !== '')
                          }
                        >
                          <Element name="Section8" className="ClimateModule">
                            <Climate
                              communityInfo={communityDetails}
                              communityDetails={communityDetails}
                              isAccessible={isAccessible}
                              publicView={publicView}
                              loggedInUserData={loggedInUserData}
                            />
                          </Element>
                        </If>
                      </If>
                      <If condition={!publicView}>
                        <Choose>
                          <When
                            condition={
                              !isAccessible &&
                              communityDetails?.gettingAround?.length > 0 &&
                              communityDetails?.gettingAround?.[0] &&
                              (communityDetails?.gettingAround?.[0]?.dedicatedBikingPaths ||
                                communityDetails?.gettingAround?.[0]?.dedicatedWalkingPaths ||
                                communityDetails?.gettingAround?.[0]?.regionalAirport ||
                                communityDetails?.gettingAround?.[0]?.localAirport ||
                                communityDetails?.gettingAround?.[0]?.publicTransType !== '' ||
                                communityDetails?.gettingAround?.[0]?.gettingAroundDesc !== '')
                            }
                          >
                            <Element name="Section9" className="GettingAroundModule">
                              <GettingAround
                                communityInfo={communityDetails}
                                communityDetails={communityDetails}
                                isAccessible={isAccessible}
                                publicView={publicView}
                                loggedInUserData={loggedInUserData}
                              />
                            </Element>
                          </When>
                          <When condition={isAccessible}>
                            <Element name="Section9" className="GettingAroundModule">
                              <GettingAround
                                communityInfo={communityDetails}
                                communityDetails={communityDetails}
                                isAccessible={isAccessible}
                                publicView={publicView}
                                loggedInUserData={loggedInUserData}
                              />
                            </Element>
                          </When>
                        </Choose>
                      </If>

                      <If condition={publicView}>
                        {
                          // communityDetails?.isRepresented &&
                          isAccessible &&
                            communityDetails?.gettingAround.length > 0 &&
                            communityDetails?.gettingAround?.[0] &&
                            (communityDetails?.gettingAround?.[0]?.dedicatedBikingPaths ||
                              communityDetails?.gettingAround?.[0]?.dedicatedWalkingPaths ||
                              communityDetails?.gettingAround?.[0]?.regionalAirport ||
                              communityDetails?.gettingAround?.[0]?.localAirport ||
                              communityDetails?.gettingAround?.[0]?.publicTransType !== '' ||
                              communityDetails?.gettingAround?.[0]?.gettingAroundDesc !== '') && (
                              <Element name="Section9" className="GettingAroundModule">
                                <GettingAround
                                  communityInfo={communityDetails}
                                  communityDetails={communityDetails}
                                  isAccessible={isAccessible}
                                  publicView={publicView}
                                  loggedInUserData={loggedInUserData}
                                />
                              </Element>
                            )
                        }
                      </If>
                      <Element name="Section10" className="EducationModule">
                        <Education
                          communityInfo={communityDetails}
                          communityDetails={communityDetails}
                          isAccessible={isAccessible}
                          publicView={publicView}
                          loggedInUserData={loggedInUserData}
                        />
                      </Element>

                      <If
                        condition={
                          (!publicView && isAccessible) ||
                          communityDetails?.healthFacilityCount > 0 ||
                          (communityDetails?.healthInsights?.length > 0 &&
                            communityDetails?.healthInsights?.[0]?.healthCareDesc !== '')
                        }
                      >
                        <Element name="Section11" className="HealthcareModule">
                          <Healthcare
                            communityInfo={communityDetails}
                            isAccessible={isAccessible}
                            publicView={publicView}
                            loggedInUserData={loggedInUserData}
                          />
                        </Element>
                      </If>
                      {/* <Element name="Section12" className="ClubsConnectionsModule">
                        <ClubsAndConnections />
                      </Element> */}
                    </When>
                  </Choose>
                  {/* <ClubsAndConnections /> */}
                </Box>

                <Box mb={2} mt={2} pl={2} pr={2} className="ViewHomesButton">
                  <Link
                    href={`${
                      communityDetails?.planetReCommunityId
                        ? `${homesBaseUrlForCommunity}${communityDetails.planetReCommunityId}`
                        : ''
                    }`}
                    target="_blank"
                    disable={false}
                    underline="none"
                  >
                    <Button variant="contained" color="primary" size="small" fullWidth>
                      View Homes
                    </Button>
                  </Link>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      ) : (
        <>
          <Container>
            <Grid container className="PageSpacing">
              <Grid item xs={12}>
                {/* No content to display */}
                {/* <Loader /> */}
              </Grid>
            </Grid>
          </Container>
        </>
      )}

      <CommunityNavigationDialog
        open={navigationDialogOpen}
        onClose={handleNavigationDialogClose}
        communityDetails={communityDetails}
        isAccessible={isAccessible}
        publicView={publicView}
      />

      {/* Login Modal - Exact copy from CommunityCard.js */}
      <Dialog
        className="CustomDialog"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          className="CustomDialogTitle"
        >
          <IconButton className="CustomCloseIcon" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent className="CustomDialogContent">
          <Login changeTabSignUp={changeTabSignUp} handleClose={handleClose} />
        </DialogContent>
      </Dialog>
    </>
  );
};

CommunityDetails.defaultProps = {};
export default CommunityDetails;
